import React from 'react';
import { PortableText } from '../elements';

const TextBlock = ({ body }) => {
  if (!body) return null;
  return <PortableText content={body} />;
};

export default TextBlock;
